import BaseModelAPI from '../BaseModelAPI';

export default class ReportMTBF extends BaseModelAPI {
	static entity = 'newreport2017';
	static entityName = 'reportmtbf';

	constructor() {

		/*APP_MODEL_DEFINITION*/
		this.filterPeriodDate = '';
		this.filterMachineCode = '';
		this.tempId = 0;
		this.startProduction = '';
		this.code = '';
		this.totalWaktuMesinBeroperasi = 0;
		this.totalFrekuensiTroubleMesin = 0;
		this.mttr = 0;
		this.mtbf = 0;
		this.totalWaktuMesinTrouble = 0;
		this.totalWaktuTroubleMesin = 0;
		this.availability = 0;
		this.isFromUpload = false;
		this.isSavedToBackend = true;
		this.uploadValidationMessage = '';
		this.uploadValidationStatus = '';
		/*END_APP_MODEL_DEFINITION*/
	}

}